import styled from "styled-components";
import {
  whiteColor,
  inputBackgroundColor,
  inputBorderColor,
  mediumFont,
  inputBackgroundHoverColor,
  primaryColor,
  dangerColor,
} from "@app/styles";

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  background-color: ${inputBackgroundColor};
  border: 2px solid ${inputBorderColor};
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  font-weight: 300;
  font-family: "Poppins", sans-serif;
  resize: none;
  line-height: 1.5;
  letter-spacing: 0.035em;
  color: #33403e;
  &:hover {
    background-color: ${inputBackgroundHoverColor};
  }
  &:active,
  &:focus {
    background-color: ${whiteColor};
    border-color: ${primaryColor};
    outline: none;
  }
  :disabled {
    pointer-events: none;
    background: #f7f7f7;
    color: #33403e;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-family: "Filson";
  letter-spacing: 0.25px;
  margin: 0 0 4px;
`;

export const Error = styled.p`
  display: block;
  font-size: 12px;
  ${mediumFont};
  color: ${dangerColor};
  margin: 4px 0 0;
`;
